import moment from 'moment';
import { dateFormat } from '../../../../constants';
import { getStopApi } from '../../../../services/StopApi/StopApi';

export const getInvoiceData = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    return response.data.invoiceDetails;
  }).catch((e) => alert(e));
};
